import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import { 
  loadMedias,
  removeMedia,
} from '../../reducers/medias';

import './MediaManager.css';

class MediaManager extends Component {

  state = {
    sortedMedias: {
      attractLoop: {
        portrait: [],
        landscape: []
      },
      campaign: {
        portrait: [],
        landscape: []
      }
    }
  }

  componentDidMount = () => { 
    this.sortMedias();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if(!this.props.isLoadingMedias && prevProps.isLoadingMedias !== this.props.isLoadingMedias) {
      this.sortMedias();
    }
  }

  sortMedias = () => {
    let sortedMedias = {
      attractLoop: {
        portrait: [],
        landscape: []
      },
      campaign: {
        portrait: [],
        landscape: []
      }
    }

    this.props.medias.forEach(media => {
      if(media.media_uploaded_id_type === 'Attract Loop') {
        if(media.orientation === 'Portrait') {
          sortedMedias.attractLoop.portrait.push(media);
        } else if (media.orientation === 'Landscape') {
          sortedMedias.attractLoop.landscape.push(media);
        }
      }
      if(media.media_uploaded_id_type === 'Campaign') {
        if(media.orientation === 'Portrait') {
          sortedMedias.campaign.portrait.push(media);
        } else if (media.orientation === 'Landscape') {
          sortedMedias.campaign.landscape.push(media);
        }
      }
    });

    this.setState({sortedMedias});
  }

  getFileURL = (absoluteURL) => {
    return `${absoluteURL}`;
  }

  removeMedia = (media) => {
    if(window.confirm(`Do you want to remove ${media.media_uploaded_id_type} ${media.media_attachment.media_name}?`)){
      this.props.removeMedia(media.media_uploaded_id, ()=> {
        this.props.loadMedias();
      });
    }
  }

  render() {
    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>Media Manager</PageTitle>
          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">

              <div className="col-md-4 offset-md-8">
                <Link to="/medias/add" className="btn btn-primary float-right">Add Media</Link>
              </div>

            </div>
            
            <table id="medias-table" className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col" colSpan="1" >Media</th>
                  <th scope="col" width="200">Actions</th>
                </tr>
              </thead>
              {this.props.isLoadingMedias &&
                <tbody>
                  <tr>
                    <td colSpan="4" className="text-center"><em>Loading Medias</em></td>
                  </tr>
                </tbody>
              }
              {!this.props.isLoadingMedias && this.props.medias.length === 0 &&
                <tbody>
                  <tr>
                    <td colSpan="4" className="text-center"><em>0 Medias</em></td>
                  </tr>
                </tbody>
              }
              {this.state.sortedMedias &&
                <tbody>
                  {this.state.sortedMedias.attractLoop.portrait.length > 0 &&
                    <React.Fragment>
                      <tr className="table-light"><th colSpan="2">Attract Loop - Portrait</th></tr>
                      {this.state.sortedMedias.attractLoop.portrait.map((media, idx) => {
                        return (
                          <tr key={`media-${media.media_uploaded_id}`} id={`media-${media.media_uploaded_id}`}>
                            <td>
                              <div className="media-displays">
                                {media.media_attachment.media_type === 'video' &&
                                  <video width="300" height="200" controls style={{float: 'left', marginRight: '20px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}}>
                                    <source type={`${media.media_attachment.media_mimetype}`} src={this.getFileURL(`${media.media_attachment.media_url}`)} />
                                  </video>
                                }
                                {media.media_attachment.media_type === 'image' &&
                                  <img key={`attachment-${media.media_attachment.attachment_id}`} src={this.getFileURL(media.media_attachment.media_url)} className="rounded float-left" alt={`${media.media_attachment.media_name}`}></img>
                                }
                                <strong>{media.media_attachment.media_name}</strong><br/>
                                {media.media_attachment.media_type}<br/>
                                {media.external_url ? media.external_url : ``}
                              </div>
                            </td>
                            <td>
                              <Link to={`/medias/${media.media_uploaded_id}`} className="btn btn-outline-secondary btn-sm">Edit</Link>&nbsp;
                              <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeMedia(media)}>Remove</button>&nbsp;
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  }
                  {this.state.sortedMedias.attractLoop.landscape.length > 0 &&
                    <React.Fragment>
                      <tr className="table-light"><th colSpan="2">Attract Loop - Landscape</th></tr>
                      {this.state.sortedMedias.attractLoop.landscape.map((media, idx) => {
                        return (
                          <tr key={`media-${media.media_uploaded_id}`} id={`media-${media.media_uploaded_id}`}>
                            <td>
                              <div className="media-displays">
                                {media.media_attachment.media_type === 'video' &&
                                  <video width="300" height="200" controls style={{float: 'left', marginRight: '20px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}}>
                                    <source type={`${media.media_attachment.media_mimetype}`} src={this.getFileURL(`${media.media_attachment.media_url}`)} />
                                  </video>
                                }
                                {media.media_attachment.media_type === 'image' &&
                                  <img key={`attachment-${media.media_attachment.attachment_id}`} src={this.getFileURL(media.media_attachment.media_url)} className="rounded float-left" alt={`${media.media_attachment.media_name}`}></img>
                                }
                                <strong>{media.media_attachment.media_name}</strong><br/>
                                {media.media_attachment.media_type}<br/>
                                {media.external_url ? media.external_url : ``}
                              </div>
                            </td>
                            <td>
                              <Link to={`/medias/${media.media_uploaded_id}`} className="btn btn-outline-secondary btn-sm">Edit</Link>&nbsp;
                              <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeMedia(media)}>Remove</button>&nbsp;
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  }
                  {this.state.sortedMedias.campaign.portrait.length > 0 &&
                    <React.Fragment>
                      <tr className="table-light"><th colSpan="2">Campaign - Portrait</th></tr>
                      {this.state.sortedMedias.campaign.portrait.map((media, idx) => {
                        return (
                          <tr key={`media-${media.media_uploaded_id}`} id={`media-${media.media_uploaded_id}`}>
                            <td>
                              <div className="media-displays" >
                                {media.media_attachment.media_type === 'video' &&
                                  <video width="300" height="200" controls style={{float: 'left', marginRight: '20px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}}>
                                    <source type={`${media.media_attachment.media_mimetype}`} src={this.getFileURL(`${media.media_attachment.media_url}`)} />
                                  </video>
                                }
                                {media.media_attachment.media_type === 'image' &&
                                  <img key={`attachment-${media.media_attachment.attachment_id}`} src={this.getFileURL(media.media_attachment.media_url)} className="rounded float-left" alt={`${media.media_attachment.media_name}`}></img>
                                }
                                <strong>{media.media_attachment.media_name}</strong><br/>
                                {media.media_attachment.media_type}
                              </div>
                            </td>
                            <td>
                              <Link to={`/medias/${media.media_uploaded_id}`} className="btn btn-outline-secondary btn-sm">Edit</Link>&nbsp;
                              <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeMedia(media)}>Remove</button>&nbsp;
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  }
                  {this.state.sortedMedias.campaign.landscape.length > 0 &&
                    <React.Fragment>
                      <tr className="table-light"><th colSpan="2">Campaign - Landscape</th></tr>
                      {this.state.sortedMedias.campaign.landscape.map((media, idx) => {
                        return (
                          <tr key={`media-${media.media_uploaded_id}`} id={`media-${media.media_uploaded_id}`}>
                            <td>
                              <div className="media-displays">
                                {media.media_attachment.media_type === 'video' &&
                                  <video width="300" height="200" controls style={{float: 'left', marginRight: '20px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}}>
                                    <source type={`${media.media_attachment.media_mimetype}`} src={this.getFileURL(`${media.media_attachment.media_url}`)} />
                                  </video>
                                }
                                {media.media_attachment.media_type === 'image' &&
                                  <img key={`attachment-${media.media_attachment.attachment_id}`} src={this.getFileURL(media.media_attachment.media_url)} className="rounded float-left" alt={`${media.media_attachment.media_name}`}></img>
                                }
                                <strong>{media.media_attachment.media_name}</strong><br/>
                                {media.media_attachment.media_type}
                              </div>
                            </td>
                            <td>
                              <Link to={`/medias/${media.media_uploaded_id}`} className="btn btn-outline-secondary btn-sm">Edit</Link>&nbsp;
                              <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeMedia(media)}>Remove</button>&nbsp;
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  }
                </tbody>
              }
            </table>
          </div>
        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  medias: state.medias.medias,
  isLoadingMedias: state.medias.isLoadingMedias
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadMedias,
      removeMedia,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MediaManager);


// WEBPACK FOOTER //
// ./src/modules/MediaManager/MediaManager.js